import React from "react";
import Home from "./scenes/Home";
import Footer from "components/Footer";

function App(): JSX.Element {
  return (
    <React.Fragment>
      <Home />
      <Footer />
    </React.Fragment>
  );
}

export default App;
